import merge from 'lodash/merge';
import { handleRequest } from './requestHandler';

export const get = (url, data, options) => handleRequest(
    url,
    data,
    options
);

export const post = (url, data, options = {}) => handleRequest(
    url,
    data,
    merge({ request: { method: 'POST' } }, options)
);

export const patch = (url, data, options = {}) => handleRequest(
    url,
    data,
    merge({ request: { method: 'PATCH' } }, options)
);

export const del = (url, data, options = {}) => handleRequest(
    url,
    data,
    merge({ request: { method: 'DELETE' } }, options)
);

export const put = (url, data, options = {}) => handleRequest(
    url,
    data,
    merge({ request: { method: 'PUT' } }, options)
);

export { useFetch } from './useFetch';
export { registerRequestResponseInterceptor, unregisterRequestResponseInterceptor } from './requestHandler';
